export const ANNOTATIONS_FETCHED = 'ANNOTATIONS_FETCHED';
export const ANNOTATIONS_UPDATE_PENDING_COUNT_BY_REVIEW =
  'ANNOTATIONS_UPDATE_PENDING_COUNT_BY_REVIEW';
export const ANNOTATIONS_UPDATE_PENDING_COUNT = 'ANNOTATIONS_UPDATE_PENDING_COUNT';
